module.exports = __webpack_public_path__ + "img/fronx-ta-racoon.360c9b73.png";